<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col sm="8">
          <v-card :dark="config.dark_background" :color="config.background_dark">
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="userList"
              :items-per-page="10"
              class="elevation-1"
              :search="search"
              :sort-by="['date_created']"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr @click="clickItem(item._id)" :key="index" v-for="(item, index) in items">
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.date_created }}</td>
                    <td>{{ item.memberStart }}</td>
                    <td>{{ item.memberEnd }}</td>
                    <td>
                      <v-btn v-on:click.stop :disabled="item._id === getUser._id" @click="makeAdmin(item)" icon :color="isAdmin(item._id).admin ? config.confirm : 'white'">
                        <v-icon v-if="isAdmin(item._id).admin">mdi-check</v-icon>
                        <v-icon v-if="!isAdmin(item._id).admin">mdi-close</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn v-on:click.stop :disabled="item._id === getUser._id" @click="deleteUser(item)" icon :color="isDeleted(item._id).deleted ? config.alert : 'white'">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-slot:top>
                <v-card-title>
                  Chipcustomizer Users
                  <v-btn icon class="mx-4" @click="startup()">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-btn
                    :color="config.primary"
                    small
                    class="mx-1"
                    :ripple="false"
                    readonly
                    @click="sendAttributes()"
                  >
                    <v-icon left v-if="!receiveEmails">mdi-checkbox-blank-outline</v-icon>
                    <v-icon left v-if="receiveEmails">mdi-checkbox-marked</v-icon>
                    <span>Recieve email notifications</span>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    label="Search..."
                    class="pa-3"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
              </template>
              <template v-slot:item.admin="{ item }">
                <v-simple-checkbox :ripple="false" v-model="item.admin"></v-simple-checkbox>
              </template>
              <template v-slot:footer>
                <v-btn
                  @click="saveChanges()"
                  elevation="0"
                  :disabled="itemsModified.length === 0"
                  class="my-4 mx-4"
                  :color="config.alert"
                >
                  Save Changes...
                </v-btn>
                <v-btn
                  @click="itemsModified = []"
                  elevation="0"
                  :disabled="itemsModified.length === 0"
                  class="my-4 mx-4"
                  :color="config.alert"
                >
                  Discard Changes
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col>
          <v-card tile elevation="0" style="height:600px" :dark="config.dark_background" :color="config.background_dark">
            <v-overlay
              absolute
              v-if="chipsLoading"
              opacity="0.2"
            >
              <v-progress-circular 
              indeterminate
              size="128"
              absolute
              :color="config.primary"
              >
              </v-progress-circular>
            </v-overlay>
            <div style="overflow-y:scroll; height:100%;">
              <v-card-title>
                User's Chips
              </v-card-title>
              <v-card-text v-if="chipList.length === 0">
                No chips found.
              </v-card-text>
              <v-hover
              v-slot:default="{ hover }"
              :key="index"
              v-for="(chip, index) in chipList"
              >
                <v-card
                  elevation="0"
                  :color="hover ? config.background_dark_slight : config.background_dark"
                  tile
                >
                  <v-list-item three-line>
                    <v-list-item-avatar
                      tile
                      size="50"
                    >
                      <v-img
                        lazy-src=""
                        :src="chip.image"
                        width="50"
                        height="50"
                        style="border-radius: 50%;"
                      >
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="headline mb-1">
                        {{chip.name}}
                        <v-overlay
                          absolute
                          opacity="0"
                          :class="hover ? 'show-btns' : 'hide-btns'"
                        >
                          <v-btn icon :loading="deleteLoading" style="pointer-events: all;" @click="editChip(chip)" class="mx-3" :color="config.confirm">
                            <v-icon>mdi-circle-edit-outline</v-icon>
                          </v-btn>
                          <v-btn icon :loading="deleteLoading" style="pointer-events: all;" @click="deleteChip(chip)" class="mx-3" :color="config.alert">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-overlay>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Created {{ getFormattedDate(chip.date_created)}}
                        <v-tooltip open-delay="100" v-if="chip.private" right :color="config.special_1">
                          <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
                            <v-icon :color="config.special_1" v-on="on" >mdi-lock-check</v-icon>
                          </template>
                          <h3>This chip is private</h3>
                        </v-tooltip>
                        <v-tooltip open-delay="100" v-if="chip.admin_created && !chip.private" right :color="config.primary">
                          <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
                            <v-icon :color="config.primary" v-on="on" >mdi-alpha-t-circle</v-icon>
                          </template>
                          <h3>This chip is being used as a template</h3>
                        </v-tooltip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-hover>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import LibraryService from '@/services/LibraryService'
import AdminService from '@/services/AdminService'
import ItemService from '@/services/ItemService'
import config from '@/config/config'
import { mapGetters } from 'vuex'
// import FSModal from '@/components/FSModal.vue'
// import Modal from '@/components/Modal.vue'

export default {
  name: 'admin-panel',
  data () {
    return {
      config,
      deleteLoading: false,
      userList: [],
      chipList: [],
      headers: [
        { text: 'Username', value: 'name'},
        { text: 'Email', value: 'email' },
        { text: 'Date Created', value: 'date_created', sort: (a, b) => this.sortDates(a, b) },
        { text: 'Membership Started', value: 'memberStart' },
        { text: 'Membership Ended', value: 'memberEnd' },
        { text: 'Admin', value: 'admin' },
        { text: 'Delete', value: 'delete', sortable: false }
      ],
      options: {},
      loading: true,
      chipsLoading: false,
      search: '',
      saved: true,
      itemsModified: [],
      receiveEmails: null
    }
  },
  methods: {
    async sendAttributes() {
      const response = await AdminService.toggleEmail({token: this.getUser.token})
      this.receiveEmails = response.data.attributes.some(element => element == 'sendEmailsAdmin')
    },
    editChip (item) {
      this.$router.push({
          name: 'create',
          params: {
              itemInfo: item
          }
      })
    },
    async deleteChip(chip) {
      try {
        this.deleteLoading = true
        await ItemService.delete({token: this.getUser.token, itemId: chip._id})
        this.clickItem(chip.user_created)
        this.deleteLoading = false
      } catch (error) {
        this.$store.dispatch('setAlert', error)
        this.deleteLoading = false
      }
    },
    addImages (array) {
      return array.map(function (item) {
        item.image = config.backendURL + '/public/icons/' + item._id + '.png'
        return item
      })
    },
    async clickItem (id) {
      try {
        this.chipsLoading = true
        const response = await AdminService.getUserCreatedPrivate({token: this.getUser.token, userId: id})
        const newList = this.addImages(response.data.items)
        this.chipList = newList
        this.chipsLoading = false
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async saveChanges () {
      try {
        await AdminService.editUsers({
          token: this.getUser.token,
          changedUsers: this.itemsModified
        })
        this.startup()
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    makeAdmin (user) {
      const item = this.isAdmin(user._id)
      if (item.admin == false) {
        if (item.exists) {
          this.itemsModified.splice(this.itemsModified.indexOf(item.result), 1, {...item.result, admin: true})
        } else if(!item.exists) {
          this.itemsModified.push({
            _id: user._id,
            admin: true,
            deleted: false
          })
        }
      } else if (item.admin == true) {
        if (item.exists) {
          this.itemsModified.splice(this.itemsModified.indexOf(item.result), 1, {...item.result, admin: false})
        } else if(!item.exists) {
          this.itemsModified.push({
            _id: user._id,
            admin: false,
            deleted: false
          })
        }
      }
    },
    isAdmin (id) {
      const result = this.itemsModified.find(item => item._id == id)
      if (!result) {
        const findInDatabase = this.userList.find(item => item._id == id)
        if (findInDatabase.admin == true) {
          return {exists: false, admin: true}
        } else {
          return {exists: false, admin: false}
        }
      } else if (result.admin == false) {
        return {exists: true, admin: false, result}
      } else if (result.admin == true) {
        return {exists: true, admin: true, result}
      }
    },
    deleteUser (user) {
      const item = this.isDeleted(user._id)
      if (item.deleted == false) {
        if (item.exists) {
          this.itemsModified.splice(this.itemsModified.indexOf(item.result), 1, {...item.result, deleted: true})
        } else if(!item.exists) {
          this.itemsModified.push({
            _id: user._id,
            admin: user.admin,
            deleted: true
          })
        }
      } else if (item.deleted == true) {
        this.itemsModified.splice(this.itemsModified.indexOf(item.result), 1, {...item.result, deleted: false})
      }
    },
    isDeleted (id) { // Return if user exists in modified list, if user is deleted, and return user
      const result = this.itemsModified.find(item => item._id == id)
      if (!result) {
        return {exists: false, deleted: false}
      } else if (result.deleted == false) {
        return {exists: true, deleted: false, result}
      } else if (result.deleted == true) {
        return {exists: true, deleted: true, result}
      }
    },
    getFormattedDate(date_string) {
      try {
        if (typeof date_string === 'string') {
          const date = new Date(date_string)
          const dtf = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' }) 
          const [{ value: mo },,{ value: da },,{ value: ye }] = dtf.formatToParts(date) 
          return `${mo} - ${da} - ${ye}`
        } else {
          return '( N/A )'
        }
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    checkAdmin () {
      if (this.getUser.admin == true) {
        this.startup()
      } else {
        this.$router.push({name: 'home'})
      }
    },
    async startup() {
      try {
        this.loading = true
        const response = await AdminService.getUsers({token: this.getUser.token})
        const newList = await response.data.users.map(element => {
          element.date_created = this.getFormattedDate(element.date_created)
          element.memberStart = this.getFormattedDate(element.memberStart)
          element.memberEnd = this.getFormattedDate(element.memberEnd)
          return element
        })
        this.receiveEmails = response.data.attributes.some(element => element == 'sendEmailsAdmin')
        this.userList = newList
        this.loading = false
        this.itemsModified = []
      } catch (error) {
        this.$store.dispatch('setAlert', error)
        this.loading = false
      }
    },
    sortDates(a, b) {
      let ac = a.toLowerCase().replace(' ', '').split('-')
      let bc = b.toLowerCase().replace(' ', '').split('-')

      if (ac[2] == bc[2]) {
        if (this.orderMonth(ac[0]) < this.orderMonth(bc[0])) { // if ac is older month
          return 1
        } else if (this.orderMonth(ac[0]) > this.orderMonth(bc[0])) { // if ac is newer month
          return -1
        } else if (this.orderMonth(ac[0]) === this.orderMonth(bc[0])) { // If same month
          if (ac[1] > bc[1]) {
            return -1
          } else if (ac[1] < bc[1]) {
            return 1
          } else if (ac[1] === bc[1]) {
            return 0
          }
        }
      } else if(ac[2] > bc[2]) {
        return a
      } else if(ac[2] < bc[2]) {
        return b
      }
    },
    orderMonth(month) {
      if (month === 'jan') return 0
      if (month === 'feb') return 1
      if (month === 'mar') return 2
      if (month === 'apr') return 3
      if (month === 'may') return 4
      if (month === 'jun') return 5
      if (month === 'jul') return 6
      if (month === 'aug') return 7
      if (month === 'sep') return 8
      if (month === 'oct') return 9
      if (month === 'nov') return 10
      if (month === 'dec') return 11
    }
  },
  components: {
    // FSModal,
    // Modal
  },
  mounted () {
    this.checkAdmin()
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
}
</script>

<style scoped>
  .show-btns {
    display: flex;
    align-content: flex-end;
    justify-content: flex-end;
    pointer-events: none;
    color: rgba(255, 255, 255, 1) !important;
  }
  .hide-btns {
    display: flex;
    align-content: flex-end;
    justify-content: flex-end;
    pointer-events: none;
    display: none;
  }
</style>